import { shopifyProvinces } from "@redotech/locale/provinces";
import { RedoShopifyCountryCode } from "@redotech/redo-inventory-common/fulfillment-country-code";

export function normalizeAddressProvince(
  province: string,
  countryCode: RedoShopifyCountryCode | undefined,
): string {
  const normalizedProvince = province.trim().toLowerCase();
  if (!normalizedProvince) {
    return "";
  }

  const matchingProvince = shopifyProvinces.find(
    (candidate) =>
      (!countryCode || candidate.countryCode === countryCode) &&
      (candidate.provinceCode.toLowerCase() === normalizedProvince ||
        candidate.province.toLowerCase() === normalizedProvince),
  );
  if (matchingProvince) {
    return matchingProvince.province;
  }

  // When the country has a province dropdown, an unmatched value renders as an
  // empty select while still submitting — drop it so the gap is visible.
  const countryHasProvinceList = shopifyProvinces.some(
    (candidate) => candidate.countryCode === countryCode,
  );
  return countryHasProvinceList ? "" : province;
}
